import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, exhaustMap } from 'rxjs/operators';
import { OrderService } from '@services/order.service';
import * as OrdersActions from './orders.actions';

@Injectable()
export class OrdersEffects {
  private readonly actions$ = inject(Actions);
  private readonly orderService = inject(OrderService);

  loadUserOrders$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrdersActions.loadUserOrders),
      exhaustMap(action =>
        this.orderService.getOrderByUser(action.page, action.size).pipe(
          map(orderPage => OrdersActions.loadUserOrdersSuccess({ orderPage })),
          catchError(error => of(OrdersActions.loadUserOrdersFailure({ error })))
        )
      )
    )
  );
}
